import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

const RouteRedirect = () => {
  const { route } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (route) {
      // Parse the route format: "delhi-to-agra" -> ["delhi", "agra"]
      const parts = route.split("-to-");

      if (parts.length === 2) {
        const fromCity = parts[0]
          .replace(/-/g, " ")
          .replace(/\b\w/g, (l) => l.toUpperCase());
        const toCity = parts[1]
          .replace(/-/g, " ")
          .replace(/\b\w/g, (l) => l.toUpperCase());

        // Redirect to home page with query parameters
        navigate(
          `/?from=${encodeURIComponent(fromCity)}&to=${encodeURIComponent(toCity)}&trip=oneWay`,
        );
      } else {
        // Invalid route format, redirect to home
        navigate("/");
      }
    }
  }, [route, navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary mx-auto"></div>
        <p className="mt-4 text-gray-600">Redirecting...</p>
      </div>
    </div>
  );
};

export default RouteRedirect;
